import { atom } from 'jotai'
import { InjuredPedestrian, InjuredPerson, Property, Witness } from '~/types'
import * as z from 'zod'
import {
    aboutYouValidator,
    aboutDriverValidator,
    whatHappenedValidator,
    aboutVehicleValidator,
} from '~/lib/zod/bb/motor/collision-no-other-vehicle/validator'

export type AboutYou = z.infer<typeof aboutYouValidator>
export type AboutDriver = z.infer<typeof aboutDriverValidator>
export type AboutVehicle = z.infer<typeof aboutVehicleValidator>
export type WhatHappened = z.infer<typeof whatHappenedValidator>

export const aboutYouAtom = atom<Partial<AboutYou>>({})
export const aboutDriverAtom = atom<Partial<AboutDriver>>({})
export const whatHappenedAtom = atom<Partial<WhatHappened>>({})
export const aboutVehicleAtom = atom<Partial<AboutVehicle>>({})
export const damageDetailsAtom = atom({})
export const otherDetailsAtom = atom({})

export const injuredPersonAtom = atom<InjuredPerson[]>([])
export const pedestrianAtom = atom<InjuredPedestrian[]>([])
export const witnessAtom = atom<Witness[]>([])
export const propertyAtom = atom<Property[]>([])

export const allFilesAtom = atom<File[]>([])
export const retainDriverData = atom<boolean>(false)
